import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser } from '@fortawesome/pro-light-svg-icons'

import { DashboardModuleListItem, UserProfileImage } from '@domain-group/suit-theme'

import { digObject, snakeToTitleCase } from '@domain-group/javascript-utils'

import useTeamMember from '@hooks/useTeamMember'
import { useRelations } from '@hooks/useUser'

import { TeamMemberModel } from '@models/types'

import TeamMemberActions from '../TeamMemberActions'

interface TeamMemberListItemProps {
  teamMember: TeamMemberModel,
}

const TeamMemberListItem = (props: TeamMemberListItemProps) => {
  const { teamMember } = props

  const teamMemberPayload = useTeamMember(teamMember)
  const {
    teamMember: {
      member_role,
    },
    user,
    // @ts-expect-error TS2339
    user: { full_name, mobile_number },
  } = teamMemberPayload

  const { image } = useRelations(user)
  const imageUrl = digObject(image, 'thumb_url')

  return (
    <DashboardModuleListItem
      imageComponent={(
        <UserProfileImage
          boxProps={{ backgroundSize: 'contain', borderRadius: 50, width: 30 }}
          imageUrl={imageUrl}
        >
          <FontAwesomeIcon icon={faUser} />
        </UserProfileImage>
      )}
      imageVariant="square"
      secondaryText={mobile_number}
      title={full_name}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {snakeToTitleCase(member_role)}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>

      <TeamMemberActions teamMemberPayload={teamMemberPayload} />
    </DashboardModuleListItem>
  )
}

export default TeamMemberListItem
